<template>
  <!-- 쉽고 빠른 의약품 등록 -->
  <div class="easy-register-wrap">
    <h2>
      간편처방 등록
      <span class="more-text">
        {{ suffleDrugLandings.length === 0 ? '쉽고 빠르게 의약품을 등록할 수 있는 서비스입니다' : '쉽고 빠르게 의약품을 등록해 보세요' }}
      </span>
    </h2>
    <div class="easy-register-items">
      <p v-if="suffleDrugLandings.length === 0" class="easy-register-empty">
        현재 등록을 추천할 의약품을 준비 중입니다
      </p>
      <div v-for="(item, i) in suffleDrugLandings" v-else :key="i" class="easy-register-item" @click.prevent="callDrugLanding(item.liveInfoId)">
        <p class="easy-register-txt">
          {{ item.title.length > 22 ? item.title.substring(0, 22) : item.title }}
        </p>
        <i />
      </div>
    </div>
  </div>
  <!-- //쉽고 빠른 의약품 등록 -->

</template>

<script>
// import axios from '@axios'
import { mapGetters, mapMutations } from 'vuex'
import { liveInfoEventHandler, callExternalApi } from '@/core/global/global-liveinfo'
import eventBus from '@/libs/event/event-bus'

export default {
  computed: {
    ...mapGetters({
      medicalDept: 'infoData/getMedicalDept',
      region: 'infoData/getRegion',
      drugLandings: 'infoData/getDrugLandings',
    }),

    suffleDrugLandings() {
      return [...this.drugLandings]
        .sort(() => Math.random() - 0.5)
        .slice(0, 12)
    },
  },
  mounted() {
    this.liveInfoEventHandler()
    // this.doSearch()
  },
  methods: {
    ...mapMutations({
      setDrugLandings: 'infoData/setDrugLandings',
    }),
    liveInfoEventHandler() {
      eventBus.$on(liveInfoEventHandler, async payload => {
        switch (payload.funcName) {
          case 'CallLandingPopupError':
            if (payload.p.resultCode) {
              const errorNumber = Number(payload.p.resultCode)
              if (errorNumber === -1) this.showAlertDialog('진료실을 호출할 수 없습니다.\n관리자에게 문의해주세요.')
              else if (errorNumber === 5) this.showAlertDialog('진료실 호출 권한이 없습니다.\n관리자에게 문의해주세요.')
              else this.showAlertDialog(`간편 처방등록 팝업 호출에 실패하였습니다. [${errorNumber}]\n관리자에게 문의해주세요.`)
            }
            break

          case 'LandingComplete':
            if (payload.p.liveInfoId) {
              const liveInfoId = Number(payload.p.liveInfoId)
              this.setDrugLandings(this.drugLandings.filter(x => x.liveInfoId !== liveInfoId)) // 완료된 liveInfoId 제외
            }
            break

          default:
            break
        }
      })
    },
    // (20251022, Sparks) 아래 API 삭제 예정
    // doSearch() {
    //   - App에서 처방정보를 받아와야 하므로 불필요할 것으로 예상
    //   axios.post('/fu/dashboard/druglandings', {
    //     CondDeptCodes: this.medicalDept || 0,
    //     CondRegionCodes: this.region || 0
    //   })
    //     .then(async rs => {
    //       this.drugLandings = rs.data
    //     })
    //     .catch(error => {
    //       this.showAlertDialog(error.response.data)
    //     })
    // },
    callDrugLanding(id) {
      callExternalApi("CallLandingPopup", String(id))
    },
  }
}
</script>
